<!-- 
/**
 * Product search results component.
 * 
 * @since 2.0.0
 * @author Fahri Rusliyadi <fahri.rusliyadi@gmail.com>
 */
-->

<template>
    <table class="table">
        <thead>
            <tr>
                <th v-for="(column, key) in columns" v-bind:key="key" scope="col">{{ column.title }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in items" v-bind:key="item.id">
                <component v-for="(column, key) in columns" v-bind:key="key" v-bind:columns="columns" v-bind:item="item" v-bind:is="column.component || 'products-search-results-item-column'"></component>
            </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        /**
         * Custom attributes. 
         * 
         * @since 2.0.0
         * @type {String[]}
         */
        props: [
            /**
             * Columns data.
             * 
             * @since 2.0.0
             * @type {Object.<String, ProductSearchResultColumn>} - {
             *      {String} Column ID: ProductSearchResultColumn
             *  }
             */
            'columns',

            /**
             * Search results.
             * 
             * @since 2.0.0
             * @type {Object[]} - [
             *      {Object} Product data.
             *  ]
             */
            'items'
        ]
    }
</script>
